import {defineStore} from "pinia";
import {onMounted, Ref, ref, watch} from "vue";
import {IFilter} from "@/types/main";
import {chatService} from "@/features/chat/chat.service";
import {useAppStore} from "@/store/app.store";
import {IChat} from "@/features/chat/chat.types";
import router from "@/router";
import {ITableHeader} from "@/types/table";
import {DateTime} from "luxon";

export const useGroupStore = defineStore("group", () => {

    const commonFilter = ref<IFilter>({
        q: '',
        date_from: '',
        date_to: '',
        time_from: '',
        time_to: '',
        shift_id: 0,
        account: 0,
        outgoing: null,
        fuzzy: true,
        fuzzy_threshold: 0.3,
        page: 1,
        page_size: 50,
        include_photo_base64: true
    })


    const headers: ITableHeader[] = [
        {
            name: "id",
            label: "No",
        },
        {
            name: "title",
            label: "Group",
        },
        {
            name: "session_name",
            label: "Account",
        },
        {
            name: "all",
            label: "All messages",
            panel: ["allMessages"],
        },
        {
            name: "text",
            label: "Text",
            panel: ["allMessages", "text"],
        },
        {
            name: "voice",
            label: "Voice & Document",
            panel: ["allMessages", "voice"],
        },
        {
            name: "call",
            label: "Call",
            panel: ["allMessages", "call"],
        },
        {
            name: "photo",
            label: "Photo & Video",
            panel: ["allMessages", "photo"],
        },
        {
            name: "all_errors",
            label: "All errors",
            type: "error",
            panel: ["allMessages", "allErrors"],
        },
        {
            name: "reply_time",
            label: "Reply Time",
            type: "error",
            panel: ["allMessages", "replyTime"],
        },
        {
            name: "unanswered",
            label: "Unanswered",
            type: "error",
            panel: ["allMessages", "unanswered"],
        },
        {
            name: "deleted",
            label: "Deleted",
            type: "error",
            panel: ["allMessages", "deleted"],
        },
        {
            name: "edited",
            label: "Edited",
            type: "error",
            panel: ["allMessages", "edited"],
        },
    ];

    async function getChats(loading: Ref) {
        try {
            loading.value = true
            let newFilter = {...commonFilter.value};
            if (newFilter.q.length == 0) {
                delete newFilter.fuzzy
                delete newFilter.fuzzy_threshold
            }
            const {data} = await chatService.getGroupChats(newFilter);
            return data
        } finally {
            loading.value = false
        }
    }

    function datepickerToUtcDateOnly(d: Date | null | undefined) {
        if (!d) return ''
        const local = DateTime.fromJSDate(d)
        return DateTime.utc(local.year, local.month, local.day).toFormat('yyyy-MM-dd')
    }

    return {commonFilter, headers, getChats};
});
